import clsx from 'clsx';
import React, { createContext, PropsWithChildren } from 'react';
import { usePageComponentsFeature } from './hooks/usePageComponentsFeature/usePageComponentsFeature';

const GlobalStyleContext = createContext({});

export const GlobalStyleProvider = ({ children }: PropsWithChildren<any>) => {
  const { globalStyleClasses } = usePageComponentsFeature();

  return (
    <GlobalStyleContext.Provider value={{}}>
      <div className={clsx(globalStyleClasses)} style={{ width: '100%' }}>
        {children}
      </div>
    </GlobalStyleContext.Provider>
  );
};
